import { h, Host } from "@stencil/core";
import { BEM } from "../../../utils/bem";
export class StageBody {
    render() {
        const block = BEM.block('stage-body');
        return (h(Host, { key: '38056f48220df6df83df04fe150fb9b516592a56', class: Object.assign({}, block.class()) }, h("slot", { key: 'ac502dc7e77ceb7ef76873307ed9da59f4c68ed9' })));
    }
    static get is() { return "bal-stage-body"; }
    static get elementRef() { return "el"; }
}
